export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_UPDATE_QUANTITIES = 'CART_UPDATE_QUANTITIES';
export const CART_SET_ITEMS = 'CART_SET_ITEMS'; 
export const CLEAR_CART = 'CLEAR_CART';
export const UPDATE_TAX = 'UPDATE_TAX';
